import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api } from '@/plugins/axios.js'
import { vue } from '@/main.js'

/**
 * Busca dados TRIA por município.
 * @param {String|Number} codIbge Código IBGE do município
 * @returns {Array}
 */
export async function getDadosMunicipio(codIbge) {
  try {
    const { data } = await api.get(`/app/v2/tria/${codIbge}`)
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Busca dados TRIA por equipe.
 * @param {String|Number} codIbge Código IBGE do município
 * @param {String} nuIne INE da equipe
 * @returns {Array}
 */
export async function getDadosEquipe(codIbge, nuIne) {
  try {
    const { data } = await api.get(`/app/v2/tria/${codIbge}/equipe/${nuIne}`)
    return data
  } catch (err) {
    console.log(err)
  }
}

/**
 * Retorna o nome da cor para pintar a linha da tabela.
 * @param {Object} item Registro
 * @returns {String}
 */
export function printTableRow(item) {
  if (item.inseguranca_alimentar == 'Moderada ou grave') {
    return 'red'
  } else {
    return 'orange'
  }
}

/**
 * Gerar PDF
 *
 * @param {array} cadastros
 * @param {object|null} selectEquipe
 * @param {object|null} microArea
 */
export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Insegurança alimentar'
  let titlePdfSave = utils.methods.titlePdf('Insegurança alimentar')

  let description_pdf =
    'Triagem para Risco de Insegurança Alimentar (TRIA) na APS'
  let headers_pdf = [
    'RESPONSÁVEL FAMILIAR',
    'NASCIMENTO',
    'MA',
    'TRIA',
    'AVALIADOS',
    'NECESSIDADE',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.resp_fam = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.micro_area = cadastros[i].micro_area
    obj.ult_tria = `${utils.methods.formatDate(
      cadastros[i].ult_tria
    )} (${utils.methods.calculateTimeDifference(
      utils.methods.formatDate(cadastros[i].ult_tria)
    )})`
    obj.respostas = cadastros[i].respostas
    obj.inseguranca_alimentar = cadastros[i].inseguranca_alimentar
    data_pdf.push(obj)
  }

  let doc = new jsPDF(utils.methods.encryptionPdf())
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe ?? selectEquipe.no_esf_eap,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.ine_esf_eap,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          let inseguranca_alimentar = data.row.raw[5]
          if (inseguranca_alimentar == 'Moderada ou grave') {
            doc.setTextColor(194, 10, 16) // vermelho
          } else {
            doc.setTextColor(255, 165, 0) // laranja
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}
